import { AppAction } from "../../../root/AppAction";
import { Folder, Footage } from "../../models/Timeline";
import DirectoryEvents from "../events/DirectoryEvents";

export interface DirectoryStore {
    directoryList: Folder[];
    footageList: Footage[];
    isLoading: boolean;
    deleteError: string;
}

const initialDirectoryStore: DirectoryStore = {
    directoryList: [],
    footageList: [],
    isLoading: false,
    deleteError: "",
};

export function directory(state: DirectoryStore = initialDirectoryStore, action: AppAction) {
    switch (action.type) {
        // ディレクトリ一覧取得
        case DirectoryEvents.GetDirComplete:
            return {
                ...state,
                directoryList: action.directoryList,
                footageList: action.footageList,
            };

        // ディレクトリ作成
        case DirectoryEvents.CreateDirStarted:
            return {
                ...state,
                isLoading: true,
            };

        case DirectoryEvents.CreateDirComplete:
            return {
                ...state,
                directoryList: action.newDirectory,
                isLoading: false,
            };

        // ディレクトリ名変更
        case DirectoryEvents.RenameDirStarted:
            return {
                ...state,
                isLoading: true,
            };

        case DirectoryEvents.RenameDirComplete:
            return {
                ...state,
                directoryList: action.renameDirectory,
                isLoading: false,
            };

        // ディレクトリ削除
        case DirectoryEvents.DeleteDirStarted:
            return {
                ...state,
                deleteError: "",
            };

        case DirectoryEvents.DeleteDirComplete:
            return {
                ...state,
                directoryList: action.delDirectory,
                deleteError: action.message,
            };

        case DirectoryEvents.UploadFootageComplete:
            return {
                ...state,
                deleteError: "",
                directoryList: action.directoryList,
                footageList: action.footageList,
            };

        // フッテージ名変更
        case DirectoryEvents.RenameFootageStarted:
            return {
                ...state,
                isLoading: true,
            };

        case DirectoryEvents.RenameFootageComplete:
            return {
                ...state,
                directoryList: action.directoryList,
                footageList: action.footageList,
                isLoading: false,
            };

        case DirectoryEvents.DeleteFootageComplete:
            return {
                ...state,
                deleteError: "",
                directoryList: action.directoryList,
                footageList: action.footageList,
            };

        case DirectoryEvents.DeleteFootageFailed:
            return {
                ...state,
                deleteError: action.error,
            };

        case DirectoryEvents.ResetDeleteError:
            return {
                ...state,
                deleteError: "",
            };
        default:
            return state;
    }
}
